<c-container class="mt-5">

  <h2>Winner Payouts</h2>

  <app-choose-your-game [message]="'Choose a game to view its winner payouts'" (gameChosenEvent)="onGameChosen($event)"></app-choose-your-game>

  @if(game) {
    <app-winner-payouts [gameSetter]="{ gameP: game, isCrossGame: true }"></app-winner-payouts>
  }

</c-container>
